/**
 * Calm shimmer placeholders for product grids (Home / Search).
 * SiteSettings CSS vars only — no brand motion.
 */
const ProductGridSkeleton = ({ count = 8 }: { count?: number }) => {
    return (
        <div className="product-grid" aria-hidden role="presentation">
            {Array.from({ length: count }, (_, i) => (
                <div
                    key={i}
                    className="flex h-full min-w-0 flex-col overflow-hidden rounded-2xl border border-[var(--accent-color)]/20 bg-white shadow-sm"
                >
                    <div className="h-10 animate-pulse bg-[color-mix(in_srgb,var(--bg-color),white_20%)]" />
                    <div className="aspect-square animate-pulse bg-[color-mix(in_srgb,var(--bg-color),transparent_25%)]" />
                    <div className="space-y-2 p-3">
                        <div className="h-4 w-4/5 animate-pulse rounded bg-[color-mix(in_srgb,var(--text-color),transparent_88%)]" />
                        <div className="h-3 w-2/5 animate-pulse rounded bg-[color-mix(in_srgb,var(--text-color),transparent_90%)]" />
                        <div className="mt-3 h-10 w-full animate-pulse rounded-full bg-[color-mix(in_srgb,var(--accent-color),transparent_70%)]" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductGridSkeleton;
